import React from 'react';
import { Icon } from '../Icon';

export const PrivacyPage: React.FC<{ onBack: () => void }> = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-theme-bg flex flex-col font-inter transition-colors duration-300">
      <nav className="bg-theme-card border-b border-theme-border px-6 py-4 sticky top-0 z-50 shadow-sm">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <button
            onClick={onBack}
            className="group flex items-center gap-2.5 text-base font-bold text-theme-muted hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
          >
            <Icon
              name="arrow-left"
              className="w-5 h-5 transform group-hover:-translate-x-1.5 transition-transform"
            />
            Voltar ao Hub
          </button>
          <div className="flex items-center gap-3">
            <span className="text-[10px] font-black px-4 py-2 rounded-xl uppercase tracking-widest shadow-sm bg-indigo-50 text-indigo-600 dark:bg-slate-800 dark:text-indigo-400">
              Privacidade
            </span>
          </div>
        </div>
      </nav>

      <main className="flex-grow max-w-4xl mx-auto w-full px-6 py-12">
        <div className="bg-theme-card rounded-3xl shadow-sm border border-theme-border p-8 md:p-12">
          <h1 className="text-4xl font-black text-theme-text mb-6">Política de Privacidade</h1>
          <p className="text-theme-muted mb-8 leading-relaxed">
            Última atualização: 25/02/2026<br />
            Esta Política de Privacidade descreve como a Calculadora PRO coleta, usa e protege suas informações.
          </p>

          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">1. Informações que Coletamos</h2>
              <div className="space-y-4 text-theme-muted">
                <p><strong>Informações Automáticas:</strong></p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Endereço IP e informações de navegador</li>
                  <li>Tipo de dispositivo e sistema operacional</li>
                  <li>Páginas visitadas e tempo de navegação</li>
                  <li>Informações de uso anônimas e agregadas</li>
                </ul>

                <p className="mt-4"><strong>Informações que Você Fornece:</strong></p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Dados inseridos nas calculadoras (não armazenados)</li>
                  <li>Comentários ou feedback (opcional)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">2. Como Usamos Suas Informações</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Utilizamos suas informações para:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Melhorar a funcionalidade do site</li>
                  <li>Analisar padrões de uso anônimos</li>
                  <li>Personalizar conteúdo e anúncios</li>
                  <li>Garantir a segurança do serviço</li>
                  <li>Cumprir obrigações legais</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">3. Cookies e Tecnologias Similares</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Utilizamos cookies para:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Lembrar suas preferências</li>
                  <li>Analisar o tráfego do site</li>
                  <li>Exibir anúncios relevantes</li>
                  <li>Melhorar a experiência do usuário</li>
                </ul>
                <p className="mt-4">Você pode gerenciar suas preferências de cookies através das configurações do seu navegador.</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">4. Compartilhamento de Informações</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Não vendemos suas informações pessoais. Compartilhamos dados apenas com:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Provedores de serviços (hospedagem, analytics)</li>
                  <li>Parceiros de publicidade (para anúncios personalizados)</li>
                  <li>Autoridades legais quando exigido por lei</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">5. Segurança dos Dados</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Implementamos medidas de segurança como:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Criptografia SSL/TLS</li>
                  <li>Firewalls e sistemas de proteção</li>
                  <li>Acesso restrito aos dados</li>
                  <li>Monitoramento constante</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">6. Seus Direitos (LGPD)</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Conforme a Lei Geral de Proteção de Dados, você tem direito a:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Acessar seus dados pessoais</li>
                  <li>Corrigir informações incorretas</li>
                  <li>Solicitar exclusão de dados</li>
                  <li>Revogar consentimento</li>
                  <li>Portabilidade de dados</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">7. Menores de Idade</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Nosso serviço não coleta intencionalmente informações de menores de 18 anos.
                  Caso identifemos coleta acidental, deletaremos imediatamente os dados.</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">8. Alterações nesta Política</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Podemos atualizar esta política periodicamente. Notificaremos usuários sobre
                  mudanças significativas através do site ou por outros meios apropriados.</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-theme-text mb-4">9. Contato</h2>
              <div className="space-y-3 text-theme-muted">
                <p>Para exercer seus direitos ou tirar dúvidas sobre esta política:</p>
                <div className="bg-theme-bg border border-theme-border rounded-xl p-4 mt-4">
                  <p><strong>Email:</strong> jurusfacil@gmail.com</p>
                  <p><strong>Resposta:</strong> Até 15 dias úteis</p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      <footer className="py-12 border-t border-theme-border text-center mt-auto">
        <p className="text-[10px] font-black text-theme-muted uppercase tracking-[0.3em]">
          Calculadora PRO • Ferramentas Úteis v4.0
        </p>
      </footer>
    </div>
  );
};
